<template>
    <div>
        <template v-if="header.hasOwnProperty('table')">
            {{ apiData[header.table][item[header.value]] }}
        </template>
        <template v-else-if="header.hasOwnProperty('format')">
            {{ header.format(item[header.value]) }}
        </template>
        <template v-else-if="header.hasOwnProperty('formatEnum')">
            {{ enumService.getCommaSeparatedEnum(header.formatEnum, item[header.value]) }}
        </template>
        <template v-else-if="typeof(item[header.value]) === 'boolean'">
            {{ item[header.value] ? 'Yes' : 'No' }}
        </template>
        <template v-else>
            {{ item[header.value] }}
        </template>
    </div>
</template>

<script>
    import enumService from '../services/enumService'
    export default {
        props: [
            'item',
            'header',
            'apiData',
        ],

        data() {
            return {
                enumService: enumService
            }
        }
    };
</script>
